<ng-template #content let-modal>
  <div class="modal-header">
    <h4>License Summary</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>APM email</label>
          <input type="email" class="form-control" [(ngModel)]="orgSalesRep.apmEmail" *ngIf="!isAPMInherited">
          <input type="email" class="form-control" [(ngModel)]="orgSalesRep.apmEmail" [readonly]="isAPMInherited" *ngIf="isAPMInherited">
          <small *ngIf="isAPMInherited" class="form-text text-muted">Inherited from parent organization</small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>APM name</label>
          <input type="text" class="form-control" [(ngModel)]="orgSalesRep.apmName" *ngIf="!isAPMInherited">
          <input type="text" class="form-control" [(ngModel)]="orgSalesRep.apmName" [readonly]="isAPMInherited" *ngIf="isAPMInherited">
          <small *ngIf="isAPMInherited" class="form-text text-muted">Inherited from parent organization</small>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <div class="form-group">
          <label>Active Licenses: <strong>{{activeLicenseCount}}</strong></label>
        </div>
        <div class="form-group" *ngIf="nextRenewalDate">
          <label>Next Renewal Date: <strong>{{nextRenewalDate | date}}</strong></label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close()">Close</button>
    <button type="button" class="btn btn-primary" (click)="saveSalesRep(organizationId)" [disabled]="isAPMInherited" *ngIf="!isAPMInherited">Save APM Info</button>
  </div>
</ng-template>
